import styled from "styled-components";

export const StyledHeader = styled.header`
  background: var(--tws-white);
  border-bottom: 1px solid var(--tws-border);
  z-index: 1030;
`;

export const StyledLogo = styled.img`
  height: 42px;
  width: auto;
  object-fit: contain;

  @media (min-width: 768px) {
    height: 52px;
  }
`;

export const StyledExitBtn = styled.button`
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
`;
